export const UserType = {
  Paid: 'PAID_USER',
  Alumni: 'ALUMNI',
  Free: 'FREE_USER',
};

export const UserTypeLabels = {
  [UserType.Paid]: 'Paid User',
  [UserType.Alumni]: 'Alumni',
  [UserType.Free]: 'Free User',
};
